/**
 * @generated SignedSource<<d880ad9a096c7950ca27fdc7b5008371>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type getDetailLabelAndValue_item$data = {
  readonly measurement: {
    readonly convertedMeasurementsList: ReadonlyArray<{
      readonly depth: string | null;
      readonly diameter: string | null;
      readonly height: string | null;
      readonly measurementUnit: string | null;
      readonly secondaryHeight: string | null;
      readonly width: string | null;
    } | null> | null;
  } | null;
  readonly pdpDetailsDisplay: ReadonlyArray<{
    readonly detailKey: string | null;
    readonly detailValues: ReadonlyArray<{
      readonly displayName: string | null;
    } | null> | null;
  } | null> | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "getDetailLabelAndValue_item";
};
export type getDetailLabelAndValue_item$key = {
  readonly " $data"?: getDetailLabelAndValue_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"getDetailLabelAndValue_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getDetailLabelAndValue_item"
};

(node as any).hash = "a8ba9388f5e6aa5e88d8adc1dceb86ea";

export default node;
